export const hasTruthyBooleanProperty = (propertyName: string) => (obj: Record<string, unknown>) =>
  Boolean(obj[propertyName]);

export const hasTruthyBooleanProperties =
  (propertyNames: string[]) => (obj: Record<string, unknown>) =>
    Boolean(propertyNames.every(prop => hasTruthyBooleanProperty(prop)(obj)));
